<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="jobs">
        <dx-data-grid
            #dataGrid
            [dataSource]="jobs"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="jobNumber" caption="Job #" width="80" [sortIndex]="0" sortOrder="desc"></dxi-column>
            <dxi-column dataField="customerName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="locationAddress" caption="Location" width="100"></dxi-column>
            <dxi-column dataField="description" caption="Description" width="200"></dxi-column>
            <dxi-column dataField="highPriority" width="50"></dxi-column>
            <dxi-column dataField="jobType.name" caption="Job Type" width="100"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'single'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                class="btn btn-success"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                <button  class="btn btn-secondary ml-2" (click)="addTime()">Add Overhead Time</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="jobs" class="mr-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
